import React from "react";
import { MergeFinancialAccountsResponse } from "@common/dto/financialAccount/mergeFinancialAccounts/merge-financial-accounts-response.dto";
import { pluralize } from "@common/helpers/string";

interface Props {
    dualReconciliationConflicts: MergeFinancialAccountsResponse["dualReconciliationConflicts"];
}

export const MergeBlockingConflicts: React.FC<Props> = ({
    dualReconciliationConflicts,
}) => {
    const dualCount = dualReconciliationConflicts.length;

    if (dualCount === 0) {
        return null;
    }

    return (
        <div className="mb-4">
            <h4>Can&apos;t merge: reconciled in both accounts</h4>
            <p className="mb-0">
                {dualCount} {pluralize("transaction", dualCount)}{" "}
                {dualCount === 1 ? "is" : "are"} reconciled in both accounts, so
                we can&apos;t decide which version to keep. Remove one of the
                reconciliations, then try the merge again.
            </p>
        </div>
    );
};
